"use client";

import { Button } from "@/components/ui/button";
import { images } from "@/config/images";
import Link from "next/link";
import Image from "next/image";
import { Headline6 } from "@/components/typography";

const features = [
  {
    number: "01",
    icon: images.features.game,
    title: "Community Game",
    description:
      "Dive into Spicenet's interactive community game where your actions shape the experience. Compete, collaborate, and have fun while earning rewards along the way.",
    cta: "Coming Soon",
    href: "/game",
    variant: "monochrome" as const,
    disabled: true,
  },
  {
    number: "02",
    icon: images.features.leaderboard,
    title: "Leaderboard & Rewards",
    description:
      "Climb the ranks and showcase your progress on the community leaderboard. The higher you go, the bigger the rewards",
    cta: "Leaderboard",
    href: "/leaderboard",
    variant: "monochrome" as const,
    disabled: false,
  },
];

export function WhatsSpicenetSection() {
  return (
    <section className="relative w-full bg-spicenet-black py-16 md:py-24">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-20">
          <h2 className="text-3xl md:text-5xl font-medium tracking-[-1.5px] text-white mb-3 md:mb-4">
            What is the Spicenet Portal?
          </h2>
          <Headline6 className="text-xs md:text-sm  text-white/70 ">
            Play, earn, and be part of the Spicenet community
          </Headline6>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="relative border-2 border-white p-8 md:p-10 flex flex-col bg-spicenet-black"
            >
              {/* Corner decorations */}
              <span className="absolute top-2 left-2 w-2 h-2 bg-white" />
              <span className="absolute top-2 right-2 w-2 h-2 bg-white" />
              <span className="absolute bottom-2 left-2 w-2 h-2 bg-white" />
              <span className="absolute bottom-2 right-2 w-2 h-2 bg-white" />

              {/* Number Badge */}
              <div className="text-white text-xs font-mono tracking-[0px]! mb-8 tracking-wider">
                /{feature.number}
              </div>

              {/* Icon */}
              <div className="mb-10 flex items-center justify-center h-32">
                <Image
                  src={feature.icon}
                  alt={feature.title}
                  width={128}
                  height={128}
                  className="object-contain max-h-full"
                />
              </div>

              {/* Title */}
              <h3 className="text-white text-base md:text-lg font-medium tracking-[-1.5px] uppercase mb-4 tracking-wide leading-tight">
                {feature.title}
              </h3>

              {/* Description */}
              <p className="text-white/60 text-xs md:text-sm leading-relaxed mb-8 flex-1">
                {feature.description}
              </p>

              {/* CTA Button */}
              {feature.disabled ? (
                <Button
                  variant={feature.variant}
                  size="default"
                  className="w-full opacity-50 cursor-not-allowed"
                  disabled
                >
                  {feature.cta}
                </Button>
              ) : (
                <Link href={feature.href} className="mt-auto">
                  <Button
                    variant={feature.variant}
                    size="default"
                    className="w-full"
                  >
                    {feature.cta}
                  </Button>
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
